var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsertEmoticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99169 1.66663C5.39169 1.66663 1.66669 5.39996 1.66669 9.99996C1.66669 14.6 5.39169 18.3333 9.99169 18.3333C14.6 18.3333 18.3334 14.6 18.3334 9.99996C18.3334 5.39996 14.6 1.66663 9.99169 1.66663ZM10 16.6666C6.31669 16.6666 3.33335 13.6833 3.33335 9.99996C3.33335 6.31663 6.31669 3.33329 10 3.33329C13.6834 3.33329 16.6667 6.31663 16.6667 9.99996C16.6667 13.6833 13.6834 16.6666 10 16.6666ZM12.9167 9.16663C13.6084 9.16663 14.1667 8.60829 14.1667 7.91663C14.1667 7.22496 13.6084 6.66663 12.9167 6.66663C12.225 6.66663 11.6667 7.22496 11.6667 7.91663C11.6667 8.60829 12.225 9.16663 12.9167 9.16663ZM7.08335 9.16663C7.77502 9.16663 8.33335 8.60829 8.33335 7.91663C8.33335 7.22496 7.77502 6.66663 7.08335 6.66663C6.39169 6.66663 5.83335 7.22496 5.83335 7.91663C5.83335 8.60829 6.39169 9.16663 7.08335 9.16663ZM10 14.5833C11.9417 14.5833 13.5917 13.3666 14.2584 11.6666H5.74169C6.40835 13.3666 8.05835 14.5833 10 14.5833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsertEmoticon);
export default __webpack_public_path__ + "static/media/insert-emoticon.b225863f3767de17489f722cab07eeb7.svg";
export { ForwardRef as ReactComponent };